export default __webpack_public_path__ + "static/media/info13_documentos_en_validacion.a2cfd753.png";